<div class="container">
  <h1 class="title"><a routerLink="/careers">Careers</a></h1>
  <app-spinner *ngIf="!ready"></app-spinner>

  <ng-container *ngIf="ready">
    <ng-container *ngIf="currentJob">
      <h1>{{currentJob.position_title}}</h1>
      <p>{{currentJob.job_location}}</p>

      <ng-container *ngIf="currentJob.industry">
        <h1>Industry</h1>
        <p>{{currentJob.industry}}</p>
      </ng-container>

      <ng-container *ngIf="currentJob.job_duration">
        <h1>Duration</h1>
        <p>{{currentJob.job_duration}}</p>
      </ng-container>

      <ng-container *ngIf="currentJob.about_tyt">
        <h1>About TYT</h1>
        <div [innerHTML]="currentJob.about_tyt | markdownToHtml | trustHtml"></div>
      </ng-container>

      <ng-container *ngIf="currentJob.job_description">
        <h1>Job Description</h1>
        <div [innerHTML]="currentJob.job_description | markdownToHtml | trustHtml"></div>
      </ng-container>

      <ng-container *ngIf="currentJob.primary_responsibilities">
        <h1>Primary Responsibilities</h1>
        <div [innerHTML]="currentJob.primary_responsibilities | markdownToHtml | trustHtml"></div>
      </ng-container>

      <ng-container *ngIf="currentJob.requirements">
        <h1>Requirements</h1>
        <div [innerHTML]="currentJob.requirements | markdownToHtml | trustHtml"></div>
      </ng-container>

      <ng-container *ngIf="currentJob.related_work_experience">
        <h1>Related Work Experience</h1>
        <p>{{currentJob.related_work_experience}}</p>
      </ng-container>

      <ng-container *ngIf="currentJob.education">
        <h1>Education</h1>
        <p>{{currentJob.education}}</p>
      </ng-container>

      <ng-container *ngIf="currentJob.equal_opportunity_employer">
        <h1>Additional</h1>
        <p>{{currentJob.equal_opportunity_employer}}</p>
      </ng-container>

      <ng-container *ngIf="currentJob.applying">
        <h1>Applying</h1>
        <p [innerHTML]="currentJob.applying | emailLink | trustHtml"></p>
      </ng-container>

      <a class="back" routerLink="/careers">back</a>
    </ng-container>

    <ng-container *ngIf="!currentJob && jobs">
      <ng-container *ngFor="let job of jobs">
        <a routerLink="/careers/{{job.id}}" class="position">
          <div class="name">
            <h2>{{job.position_title}}</h2>
            <p>{{job.job_location}}</p>
            <p>{{job.summary_job_description}}</p>
          </div>

          <div class="icon">
            <mat-icon>chevron_right</mat-icon>
          </div>
        </a>
      </ng-container>
    </ng-container>

    <ng-container *ngIf="!currentJob && jobs.length === 0">
      <p>No open positions at the moment, come back another time.</p>
    </ng-container>
  </ng-container>

</div>